import { useScopedSelector } from 'ia-react-core';
import React, { FC } from 'react';
import { PersonalInformation } from '../../interfaces/PersonalInformation';
import { PersonalInfoResourceInfo } from '../PersonalInformationResource/PersonalInformationResource';

export interface FirstNameProps { }

const FirstName: FC<FirstNameProps> = () => {
  const obj: PersonalInformation = useScopedSelector(PersonalInfoResourceInfo.dataDst);

  return (
    <span data-testid="FirstName">{obj?.identification?.firstName}</span>
  );
};

export default FirstName;
